module.exports = __webpack_public_path__ + "af8f0e4371beea5ac9d2c50a4fb2a502.png";